export const ONBOARDING_SECTIONS = [
  'personal',
  'credentials',
  'licenses',
  'specialties',
  'about'
] as const

export type OnboardingSectionId = (typeof ONBOARDING_SECTIONS)[number]
